module.exports = __webpack_public_path__ + "img/Interview.af8fbd54.svg";